export default __webpack_public_path__ + "static/media/sample-csv.12751ec9.csv";